import Wrap from "../../../components/wrap";
import integration from "../../../assets/imgs/integration.jpg"

export default function Integration() {

    return (
        <section className="integration-section">
            <Wrap>
                <h2 className="section-title">Detailed Reporting System</h2>
                <p className="section-desc text-black">Allows you to monitor estimated earnings, updating them in 60-minute intervals. Through Pixad reports, you can assess which ad formats or placements are performing best and which are generating more revenue, enabling you to track and optimize your ad inventory.</p>
                <img src={integration} alt="Pixad Integration" />
            </Wrap>
        </section>
    )
}
